// Utilities derived from route pathnames

const SUPERADMIN_PREFIXES = [
  '/superadmin_dashboard',
  '/superadmin_storage',
  '/superadmin_ai_usage',
  '/superadmin_upgrade_requests',
  '/create_cara_admin',
  '/superadmin_manage_admins',
  '/superadmin_tenure_tracker',
  '/edit_cara_admin',
  '/view_cara_admin',
  '/create_cara_vrm',
  '/create_super_admin',
  '/superadmin_ask_the_expert',
  '/superadmin_vrm_mapping',
  '/policy_library_admin',
  '/create_offsec_staff',
  '/superadmin_offsec_staff_mapping',
  '/superadmin_announcements',
  '/superadmin_create_package',
  '/create_cara_admin_v2',
  '/superadmin_packages',
  '/create_internal_department',
  '/internal_departments',
  '/create_internal_role',
  '/internal_roles',
  '/create_internal_staff',
  '/internal_staff',
  '/client_360',
  '/superadmin_onboarding'
];

export function isSuperadminRoute(pathname) {
  if (pathname.includes('_login')) return false;
  return SUPERADMIN_PREFIXES.some(prefix => pathname.startsWith(prefix));
}
